var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-wrapper"},[_c('setting-header',{attrs:{"title":_vm.title,"onlyBackButton":true},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }